import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoSizeReducerConfig } from '@/data/landingConfig/landingVideoSizeReducerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoSizeReducer } from './schemaObject';

interface Props {}
const VideoSizeReducer: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoSizeReducer} />
			<VideoLandingTemplate
				data={landingVideoSizeReducerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoCompressor()}
			/>
		</>
	);
};

export default VideoSizeReducer;
